/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
var dd = require("ES/lib/dd");
var ErrorAlert = require("ES/widgets/ErrorAlert");

module.exports = dd.createClass({
  getInitialState: function () {
    return { read_error_msg: null };
  },
  render: function () {
    return dd.div(
      null,
      dd.h3(null, "HighLevel CRM connection"),
      dd.p(
        {},
        "The connection settings for the HighLevel CRM are on ",
        dd.a({ href: "/dashboard/high-level" }, "your main dashboard ->")
      ),
      ErrorAlert({ message: this.state.read_error_msg })
    );
  },
});



// WEBPACK FOOTER //
// ./src/components/account_settings/connect/Highlevel.js